var React = require('react');

function TooltipInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.9321 17.5C15.0743 17.5 18.4321 14.1421 18.4321 10C18.4321 5.85786 15.0743 2.5 10.9321 2.5C6.78999 2.5 3.43213 5.85786 3.43213 10C3.43213 14.1421 6.78999 17.5 10.9321 17.5Z","stroke":"none","fill":"#D9D9D9","strokeWidth":"1","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M10.3071 9.375H10.9321V13.75H11.5571","stroke":"#000000","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M10.7759 7.5C11.2936 7.5 11.7134 7.08027 11.7134 6.5625C11.7134 6.04473 11.2936 5.625 10.7759 5.625C10.2581 5.625 9.83838 6.04473 9.83838 6.5625C9.83838 7.08027 10.2581 7.5 10.7759 7.5Z","fill":"#000000","key":2})]);
}

TooltipInline.defaultProps = {"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none"};

module.exports = TooltipInline;

TooltipInline.default = TooltipInline;
